export default __webpack_public_path__ + "slider-section-v2.png";